import React, { useRef, forwardRef, useImperativeHandle } from "react";
import ReactDOM from "react-dom";
import styles from "./Modal.module.css";

const Modal = forwardRef((props, ref) => {
  const dialogRef = useRef(null);
  const animationDuration = 300; // ms, moet overeenkomen met de CSS-animatie duur

  const handleOpen = () => {
    dialogRef.current?.showModal();
    dialogRef.current.classList.remove(styles.animateOut);
    dialogRef.current.classList.add(styles.animateIn);
  };

  const handleClose = () => {
    if (typeof props.beforeClose === "function") {
      // Call the beforeClose function if provided
      props.beforeClose();
    }
    if(dialogRef && dialogRef.current) {
      // Start the fade-out animation
      dialogRef.current.classList.remove(styles.animateIn);
      dialogRef.current.classList.add(styles.animateOut);
      // Close the modal after the animation duration
      setTimeout(() => {
        dialogRef.current?.close();
        dialogRef.current.classList.remove(styles.animateOut);
      }, animationDuration);
    }
  };

  useImperativeHandle(ref, () => ({
    open: () => handleOpen(),
    close: () => handleClose(),
  }));

  const handleOutsideClick = (e) => {
    if (e.target === dialogRef.current) {
      handleClose();
    }
  };

  return ReactDOM.createPortal(
    <dialog
      ref={dialogRef}
      className={styles.modal}
      onClick={handleOutsideClick}
    >
      <div
        className={styles.modalContent}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={styles.closeButton}
          onClick={handleClose}
        >
          &times;
        </button>
        {props.children}
      </div>
    </dialog>,
    document.getElementById("modal-root")
  );
});

export default Modal;
